import React from "react";

/** Authoritative, backend-computed badge: this is the customer's FIRST-EVER Ponesi order at THIS
 * restaurant. The panel never computes it — it only renders `new_customer_status`. */
export function NewCustomerBadge({ o, className = "" }) {
  if (o?.new_customer_status !== "NEW") return null;
  const rewarded = o?.new_customer_reward?.reward_status === "REWARDED";
  return (
    <span data-testid={`new-customer-badge-${o?.order_number}`}
      className={`text-[10px] font-black uppercase tracking-wider rounded-full px-2 py-0.5 shrink-0 ${rewarded ? "bg-brand-green text-white" : "bg-brand-green/15 text-brand-green"} ${className}`}>
      Novi kupac
    </span>
  );
}
